import React, { Component } from 'react';
import { connect } from 'react-redux';
import { clone, find } from 'lodash';
import * as util from 'lib/utility';
import * as actions from 'state/modules/assign';
import { VirtualizedSelect } from 'containers';
import styles from './PopupCustomerExperience.css';

const debug = _debug('app:PopupCustomerExperience');

let idMappingToValue = [];

class PopupCustomerExperience extends Component {
  static propTypes = {
    closeModal: React.PropTypes.func,
    wholeData: React.PropTypes.shape({}),
    strings: React.PropTypes.shape({}),
    inspectionsDataAll: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    updateInspectionsData: React.PropTypes.func,
    popupErrorLabel: React.PropTypes.func
    // updateInspectionsDisposition: React.PropTypes.func
  };

  constructor(props) {
    debug(props);
    super(props);
    this.state = { valueSelected: [], updateDropdownStyle: false, value: '' };
  }

  componentWillMount() {
    const wholeData = this.props.wholeData;
    const customerexperience = wholeData.cica_customerexperience;
    debug('### wholeData', wholeData);
    if (customerexperience) {
      const customerExperienceArray = [];
      customerExperienceArray.push(customerexperience);
      const customerexperienceLabel =
        customerExperienceArray.map(value => util.getCustomerExperience(value));
      this.setState({ valueSelected: customerexperienceLabel });
    } else {
      this.setState({ valueSelected: [] });
    }
  }

  handleDropdownChange = (value) => {
    this.setState({ value }, () => {
      if (this.state.value) {
        this.setState({ updateDropdownStyle: false });
      }
    });
  }

  updateFilter = (key, value) => {
    let valueSelected;
    const request = new Promise((resolve) => {
      valueSelected = value && value.length ? value.map(item => item.label) : [];
      this.setState({ valueSelected });
      this.setState({ updateDropdownStyle: false });
      resolve(valueSelected);
    });
    return request;
  };

  updateInspectionData = () => {
    const inspectionData = this.props.wholeData;
    const dataId = inspectionData.id;
    let correctData = {};
    const submitData = {};
    if (this.state.valueSelected.length > 0) {
      this.props.inspectionsDataAll.forEach((data) => {
        if (data.id.indexOf(dataId) > -1) {
          correctData = clone(data);
          const selectedCustomerExperience = idMappingToValue.filter(mappingValue => (
            find(this.state.valueSelected, selectedValue => selectedValue === mappingValue.label)
          ));
          const secondCustomerExperienceValue =
            selectedCustomerExperience.map(value => value.value);
          correctData.cica_customerexperience = parseInt(secondCustomerExperienceValue); // eslint-disable-line
          submitData.cica_couldnotcntowner = null;
          correctData.cica_couldnotcntowner = null;
          submitData.cica_isduplicate = false;
          correctData.cica_isduplicate = 0;
        }
      });
      console.log('correctData==>', correctData);
      console.log('submitData==>', submitData);
      debug(submitData);
      this.props.updateInspectionsData(correctData);
      this.props.closeModal();
      // this.props.updateInspectionsDisposition(correctData.id, submitData)
      // .catch((error) => {
      //   debug(error);
      // });
    } else {
      this.setState({ updateDropdownStyle: true });
    }
  }

  customerExperiencelist = (list) => {
    idMappingToValue =
    list.map(item => (
      {
        value: item.value,
        label: item.label
      }));
    return list.map(item => (
      {
        value: item.label,
        label: item.label,
        clearableValue: false
      }), 'value');
  };

  render() {
    debug('### this.props.wholeData', this.props.wholeData);
    const { strings } = this.props;
    const customerExp = util.dropDownData(strings).customerExperience;
    return (
      <div className={styles.popupBody}>
        <div className={styles.pageDropDown}>
          <span className={styles.labelText}>
            {strings.whatcustomerexperience}
          </span>
          <div className={styles.dropdown}>
            <VirtualizedSelect
              options={this.customerExperiencelist(customerExp)}
              type={this.state.valueSelected}
              updateFilter={this.updateFilter}
              filterValues={this.state.valueSelected}
              tetherToWindow={false}
              labelKey="label"
              valueKey="value"
              placeholder={strings.select}
              hiddenSearch
              placeholderStyle
              singleSelect
              menuStyle={{ overflow: 'hidden', 'min-height': '200px' }}
              menuContainerStyle={{ 'min-height': '200px' }}
              maxHeight={250}
              className={this.state.updateDropdownStyle ? styles.pageDropDownError : undefined}
            />
            {this.state.updateDropdownStyle && this.props.popupErrorLabel}
          </div>
        </div>
        <div className={styles.saveDiv}>
          <div className={styles.buttonHolder}>
            <button
              className={styles.saveSpan}
              onMouseDown={() => this.updateInspectionData()}
            >{strings.save}</button>
            <button
              className={styles.cancelSpan}
              onMouseDown={() => this.props.closeModal()}
            >{strings.cancel}</button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  inspectionsDataAll: state.assign.inspectionsData
});

export default connect(mapStateToProps, actions)(PopupCustomerExperience);



// WEBPACK FOOTER //
// ./src/components/PopupCustomerExperience/PopupCustomerExperience.js